export function formatPrice(totalPrice: number): string {
  const totalPriceString = totalPrice.toFixed(0);
  const totalPriceWithCents =
    totalPriceString.slice(0, -2) + '.' + totalPriceString.slice(-2);

  return totalPriceWithCents;
}
